import firebase from 'firebase';

const firebaseConfig = {
    apiKey: "AIzaSyDOKDsqH--M3VvLH6lssaEFsuNzJHf46rY",
    authDomain: "facebook-clone-a3c37.firebaseapp.com",
    databaseURL: "https://facebook-clone-a3c37.firebaseio.com",
    projectId: "facebook-clone-a3c37",
    storageBucket: "facebook-clone-a3c37.appspot.com",
    messagingSenderId: "38053734812",
    appId: "1:38053734812:web:c9941d98a8e50e6defc059",
    measurementId: "G-N9MYTVVB7R"
  };

const firebaseApp = firebase.initializeApp(firebaseConfig);
export const auth = firebase.auth();
export const provider = new firebase.auth.GoogleAuthProvider();
